import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slide1 from "../imgs/sliderImgs/slide1.png"
import slide2 from "../imgs/sliderImgs/slide2.png"
import slide3 from "../imgs/sliderImgs/slide3.png"
import slide4 from "../imgs/sliderImgs/slide4.png"
// import {slide1,slide2,slide3,slide4} from "sliderImgs"

function AutoPlay() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed: 1500
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>
        <div >
          <img src={slide1} alt="" width={1400} height={525}/>
        </div>
        <div>
        <img src={slide2} alt="" width={1400} height={525}/>  
              </div>
        <div>
        <img src={slide3} alt="" width={1400} height={525}/>     
           </div>
        <div>
        <img src={slide4} alt="" width={1400} height={525}/>  
              </div>
       
      </Slider>
    </div>
  );
}

export default AutoPlay;
